import { createAction } from "@reduxjs/toolkit"

// Actions that are common to multiple slices.

export const urlChanged = createAction("urlChanged")
